
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


export default {
props: {
matchInfo: Object
},
components: {
Flexbox,
FlexboxItem
},
mounted(){
this.reload();
},
methods: {
toMatchLive() {
this.$router.push({
path: '/match_info', query: {
matchId: this.matchInfo.id,
homeTeamId: this.matchInfo.homeTeamId,
visitTeamId: this.matchInfo.vistingTeamId,
currentTab: 'matchLiveTab'
}
});
},
viewMatch(){
this.$router.push({
path: '/match_info', query: {
matchId: this.matchInfo.id,
homeTeamId: this.matchInfo.homeTeamId,
visitTeamId: this.matchInfo.vistingTeamId,
currentTab: 'matchScoresTab'
}
});
},
getRoundName (roundType, roundNum, roundTitle) {
var roundName = "--";

if(roundType=='cup_1'){
roundName = "决赛"
}
else if(roundType=='cup_2'){
roundName = "半决赛"
}
else if(roundType=='cup_4'){
roundName = "1/4决赛"
}
else if(roundType=='cup_8'){
roundName = "1/8决赛"
}
else if(roundType=='cup_16'){
roundName = "1/16决赛"
}
else if(roundType=='cup_32'){
roundName = "1/32决赛"
}
else if(roundType=='cup_64'){
roundName = "1/64决赛"
}
else if(roundType=='cup_128'){
roundName = "1/128决赛"
}
else if(roundType=='cup_team'||roundType=='league'){
roundName = "第"+roundNum+"轮"
}
else if(roundType== 'customized_rank_round'){
roundName = roundTitle
} else {
var arr = roundType.split("_")
roundName = +arr[3]+"-"+arr[2]+"名排位赛"
}
return roundName;
},
reload(){
this.objInfo = this.matchInfo;
console.log(this.objInfo, '---------this.objInfo---------')
this.objInfo.startTime = this.formatTime(this.matchInfo.startDate)
this.title = this.genTitle();
this.score = this.genScore();
},
genTitle(){
var group = "";
if(this.matchInfo && this.matchInfo.cupGroupName) {
group =  this.matchInfo.cupGroupName + "组";
}
var number = "";

if(this.matchInfo && this.matchInfo.round) {
number = this.getRoundName(this.matchInfo.round.type,this.matchInfo.round.number,this.matchInfo.round.title);
}

return group + (number!=""?" "+number:"");
},
genScore() {
return "VS"
},
formatTime(time) {
if(!time) return '';

var date = new Date(parseInt(time));
var hours = date.getHours()
var minutes = date.getMinutes()
if (hours >= 0 && hours <= 9) {
hours = '0' + hours
}
if (minutes >= 0 && minutes <= 9) {
minutes = '0' + minutes
}
return hours + ':' + minutes
}
},
data () {
return {
title:"",
score:"",
objInfo:{},
}
},
watch: {
matchInfo(curVal, oldVal){
this.reload();
}
}
}



// WEBPACK FOOTER //
// ./src/components/league/matchSimpleUnstart.vue